// src/components/intake/intakeNav.js
import { onboardingRouteFor } from "../../shared/_helpers/onboardingRoutes";
import { GENERIC_ERROR } from "../onboarding/onboardingCopy";
import { SAVE_FAILED, STATUS_NEED } from "./intakeCopy";

// Where the intake screens send the client. Stage pages come from the one
// stage → page map (onboardingRoutes.js); the page ORDER comes from the
// served `pages` array, never from here.
export const YOURE_IN_PATH = onboardingRouteFor("trial_start");
export const DASHBOARD_PATH = onboardingRouteFor("intake");
export const QUESTIONS_PATH = "/questionnaire";
export const intakePath = (pageKey) => `/intake/${pageKey}`;
// Every dashboard edit link opens the Questions page item (decision 27).
export const questionsEditPath = (pageKey, part) =>
  `${QUESTIONS_PATH}?edit=${pageKey}${part ? `&part=${part}` : ""}`;

// The line a failed page save shows, by the server's error code (backend
// plan, Global Constraints): the vault is down → "couldn't save", entries
// kept; not_answered → that page's status line; anything else → the server's
// message.
export const saveFailure = (err) => {
  const body = err?.response?.data;
  if (body?.code === "vault_unavailable") return SAVE_FAILED;
  if (body?.code === "not_answered")
    return STATUS_NEED[body.statusKey] ?? GENERIC_ERROR;
  return body?.message || GENERIC_ERROR;
};
